<div *ngIf="isLoading" class="text-center p-5">
  <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: #007ad9"></i>
  <h4 class="mt-3">Saving Printing Configuration</h4>
</div>

<div *ngIf="!isLoading">
  <div class="p-4">
    <div class="flex align-items-center mb-4" style="min-height: 40px">
      <span class="font-bold mr-2" style="min-width: 180px">Bartender URL:</span>
      <ng-container *ngIf="!isBartenderEditing">
        <span>{{ bartenderUrl || 'Not configured' }}</span>
        <button pButton icon="pi pi-pencil" text severity="secondary" class="ml-2" (click)="onEditBartenderUrl()"></button>
      </ng-container>
      <ng-container *ngIf="isBartenderEditing">
        <input pInputText [(ngModel)]="editBartenderUrl" style="width: 22rem" />
        <button pButton icon="pi pi-check" severity="success" text style="font-size: 1.5rem" (click)="onApplyBartenderUrl()"></button>
        <button pButton icon="pi pi-times" severity="danger" text style="font-size: 1.5rem" (click)="onCancelBartenderUrl()"></button>
      </ng-container>
    </div>

    <div class="flex align-items-center mb-4" style="min-height: 40px">
      <span class="font-bold mr-2" style="min-width: 180px">Bartender Library ID:</span>
      <ng-container *ngIf="!isLibraryIdEditing">
        <span>{{ libraryId || 'Not configured' }}</span>
        <button pButton icon="pi pi-pencil" text severity="secondary" class="ml-2" (click)="onEditLibraryId()"></button>
      </ng-container>
      <ng-container *ngIf="isLibraryIdEditing">
        <input pInputText [(ngModel)]="editLibraryId" style="width: 25rem" placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX" />
        <button pButton icon="pi pi-check" severity="success" text style="font-size: 1.5rem" (click)="onApplyLibraryId()"></button>
        <button pButton icon="pi pi-times" severity="danger" text style="font-size: 1.5rem" (click)="onCancelLibraryId()"></button>
      </ng-container>
    </div>
    <div class="mb-4">
      <div class="flex align-items-center justify-content-between mb-2">
        <span class="font-bold">Available Printers:</span>
        <button pButton label="Add Printer" icon="pi pi-plus" size="small" (click)="openAddPrinterDialog()"></button>
      </div>
      <div *ngIf="printerList.length === 0" class="text-muted p-3 border-round surface-100">
        <i class="pi pi-info-circle mr-2"></i>
        No printers configured. Click "Add Printer" to add one.
      </div>
      <div *ngIf="printerList.length > 0" class="border-1 surface-border border-round p-2">
        <div *ngFor="let printer of printerList" class="flex align-items-center justify-content-between p-2 hover:surface-100 border-round">
          <span>{{ printer }}</span>
          <button pButton icon="pi pi-times" text severity="danger" size="small" (click)="removePrinter(printer)"></button>
        </div>
      </div>
    </div>

    <div class="mb-4">
      <div class="flex align-items-center justify-content-between mb-2">
        <span class="font-bold">Available Label Templates:</span>
        <button pButton label="Add Label Template" icon="pi pi-plus" size="small" (click)="openAddLabelDialog()"></button>
      </div>
      <div *ngIf="labelTemplateList.length === 0" class="text-muted p-3 border-round surface-100">
        <i class="pi pi-info-circle mr-2"></i>
        No label templates configured. Click "Add Label Template" to add one.
      </div>
      <div *ngIf="labelTemplateList.length > 0" class="border-1 surface-border border-round p-2">
        <div *ngFor="let label of labelTemplateList" class="flex align-items-center justify-content-between p-2 hover:surface-100 border-round">
          <span>{{ label }}</span>
          <button pButton icon="pi pi-times" text severity="danger" size="small" (click)="removeLabelTemplate(label)"></button>
        </div>
      </div>
    </div>
    <div class="flex justify-content-end gap-2 mt-4">
      <p-button label="Save Configuration" icon="pi pi-check" (click)="savePrintingConfiguration()" [disabled]="!pageVars.isDirty"></p-button>
    </div>
  </div>
</div>

<p-dialog
  styleClass="processing-dialog"
  [(visible)]="showAddPrinterDialog"
  header="Add New Printer"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '500px' }">
  <div class="mt-1">
    <p-floatlabel variant="on">
      <input pInputText id="printerName" [(ngModel)]="newPrinterName" class="w-full" />
      <label for="on_label">Printer Name</label>
    </p-floatlabel>
  </div>
  <div class="audit-text-small">Enter the exact name of the printer as configured in Bartender</div>
  <ng-template #footer>
    <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
      <p-button
        label="Cancel"
        icon="fa fa-times"
        severity="danger"
        size="small"
        [raised]="true"
        data-testid="cancelAddNewPrinter"
        (click)="closeAddPrinterDialog()" />
      <p-button
        label="Save"
        icon="fa fa-check"
        severity="success"
        size="small"
        [raised]="true"
        data-testid="createNewPrinter"
        (click)="addPrinter()"
        [disabled]="!newPrinterName.trim()" />
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  styleClass="processing-dialog"
  [(visible)]="showAddLabelDialog"
  header="Add New Label Template"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '500px' }">
  <div class="mt-1">
    <p-floatlabel variant="on">
      <input pInputText id="labelPath" [(ngModel)]="newLabelTemplatePath" class="w-full" />
      <label for="on_label">Label Template</label>
    </p-floatlabel>
  </div>
  <div class="audit-text-small">Enter the relative path to the label template within the Bartender library (e.g. ch-insecta/Label1.btw)</div>
  <ng-template #footer>
    <div class="border-top-1 surface-border pt-2 flex justify-content-between w-full">
      <p-button
        label="Cancel"
        icon="fa fa-times"
        severity="danger"
        size="small"
        [raised]="true"
        data-testid="cancelAddNewLabelTemplate"
        (click)="closeAddLabelDialog()" />
      <p-button
        label="Save"
        icon="fa fa-check"
        severity="success"
        size="small"
        [raised]="true"
        data-testid="createNewLabelTemplate"
        (click)="addLabelTemplate()"
        [disabled]="!newLabelTemplatePath.trim()" />
    </div>
  </ng-template>
</p-dialog>
